import {
  Checkbox,
  FormControlLabel,
  MenuItem,
  Select,
} from '@material-ui/core';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import {
  Card,
  Col,
  CardBody,
  Form,
  Row,
  FormGroup,
  Input,
  Label,
  Button,
  Modal,
  CardHeader,
  Table,
} from 'reactstrap';
import api from 'services/api';
import { PropostaContext } from 'views/pages/Proposta';
import mensagemAtingirMeta from 'utils/mensagemAtingirMeta';
import { Alert } from '@material-ui/lab';
import { MateriaisContext } from '../Materiais';

// eslint-disable-next-line no-shadow
export enum Opcoes {
  Proposta = 'Proposta',
  Configuracao = 'Configuracao',
}

interface iParam {
  propostaVersaoId?: number;
  configuracaoId?: number;
  tipo: string;
  carregarFinalidade?: boolean | false;
  opcoes: Opcoes;
  isSinergia?: boolean;
  callbackFn?: (...args: any[]) => any;
}

export default function ImportarExcel({
  propostaVersaoId,
  configuracaoId,
  tipo,
  carregarFinalidade,
  opcoes,
  isSinergia = false,
  callbackFn,
}: iParam): JSX.Element {
  const { setPrecosDesatualizados } = useContext(PropostaContext);

  const { triggerUpdateMaterial } = useContext(MateriaisContext);

  const [formModalState, setFormModalState] = useState(false);
  const [modalConfirmacaoState, setModalConfirmacaoState] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const [fileToSend, setFileToSend] = useState('');
  const [finalidade, setFinalidade] = useState('');

  const [sessao, setSessao] = useState('');
  const [dadosCarregados, setDadosCarregados] = useState([] as any[]);

  const [isImportarSemCadastro, setIsImportarSemCadastro] = useState(false);

  async function carregarDados() {
    setIsSaving(true);
    try {
      await api.post(`/proposta/versao/${propostaVersaoId}/importar-dados`, {
        sessao,
        tipo,
        finalidade,
      });

      toast.success(`Itens importados com sucesso`);

      setSessao('');
      setModalConfirmacaoState(false);
      setDadosCarregados([]);
      if (callbackFn) {
        callbackFn();
      }

      await mensagemAtingirMeta(
        `Foi adicionado um equipamento importado na proposta`,
        Number(propostaVersaoId),
      );

      triggerUpdateMaterial();
    } catch (error: any) {
      const mensagem = `Não foi possível prosseguir com a carga dos dados. ${error?.response?.data?.message}`;

      throw mensagem;
    } finally {
      setIsSaving(false);
    }
  }

  async function carregarDadosConfiguracao() {
    setIsSaving(true);
    try {
      await api.post(
        `/proposta/configuracao/${configuracaoId}/importar-dados`,
        {
          sessao,
          tipo,
          finalidade,
          isImportarSemCadastro,
        },
      );

      toast.success(`Itens importados com sucesso`);
      setSessao('');
      setModalConfirmacaoState(false);
      setDadosCarregados([]);
      if (callbackFn) {
        callbackFn();
      }
      // triggerUpdateMaterial();
    } catch (error: any) {
      const mensagem = `Não foi possível prosseguir com a carga dos dados. ${error?.response?.data?.message}`;

      throw mensagem;
    } finally {
      setIsSaving(false);
    }
  }

  async function uploadFile() {
    if (!fileToSend) {
      toast.error(`Selecione um arquivo`);
      return;
    }

    if (carregarFinalidade && !['M', 'R', 'E'].includes(finalidade)) {
      toast.error(`A finalidade é obrigatória`);
      return;
    }

    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append('file', fileToSend);
      formData.append('tipo', tipo);
      formData.append('isSinergia', String(isSinergia));

      const retorno = await api.post(
        `/upload/xlsx?propostaVersaoId=${propostaVersaoId}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      if (retorno.data.registros && retorno.data.registros.length) {
        setDadosCarregados(retorno.data.registros);

        setSessao(retorno.data.sessao);

        // Desativa essa modal e abre a outra
        setIsLoading(false);
        setFormModalState(false);
        setModalConfirmacaoState(true);
      } else {
        toast.error(`O processamento não retornou nenhum item`);
      }
    } catch (error: any) {
      const mensagem = `Não foi possível prosseguir com o upload do arquivo. ${error?.response?.data?.message}`;

      throw mensagem;
    } finally {
      setFileToSend('');

      const fileInput = document.getElementById(
        'fileUpload',
      ) as HTMLInputElement;

      if (fileInput) {
        fileInput.value = '';
      }

      setIsLoading(false);
    }
  }

  async function uploadFileConfiguracao() {
    if (!fileToSend) {
      toast.error(`Selecione um arquivo`);
      return;
    }

    if (carregarFinalidade && !['M', 'R', 'E'].includes(finalidade)) {
      toast.error(`A finalidade é obrigatória`);
      return;
    }

    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append('file', fileToSend);
      formData.append('tipo', tipo);
      formData.append('isSinergia', String(isSinergia));

      const retorno = await api.post(
        `/upload/xlsx/configuracao?orcamentoId=${configuracaoId}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      if (retorno.data.registros && retorno.data.registros.length) {
        console.log(retorno.data);
        setDadosCarregados(retorno.data.registros);
        setSessao(retorno.data.sessao);

        // Desativa essa modal e abre a outra
        setIsLoading(false);
        setFormModalState(false);
        setModalConfirmacaoState(true);
      } else {
        toast.error(`O processamento não retornou nenhum item`);
      }
    } catch (error: any) {
      const mensagem = `Não foi possível prosseguir com o upload do arquivo. ${error?.response?.data?.message}`;

      throw mensagem;
    } finally {
      setFileToSend('');

      const fileInput = document.getElementById(
        'fileUpload',
      ) as HTMLInputElement;

      if (fileInput) {
        fileInput.value = '';
      }

      setIsLoading(false);
    }
  }

  function mostrarAlerta() {
    let temItemIncompleto = false;
    let temItemErro = false;

    dadosCarregados.some(item => {
      if (!item.valorEncontrado) {
        temItemIncompleto = true;
      }
      if (!item.itemEncontrado) {
        temItemErro = true;
      }
      return temItemIncompleto && temItemErro;
    });

    if (!temItemErro && !temItemIncompleto) {
      return '';
    }

    return (
      <>
        {temItemErro && (
          <Alert severity="error" variant="filled" className="mb-2">
            <strong>Atenção!</strong> Os itens em vermelho não foram
            encontrados. Verifique se os códigos estão corretos e se estão
            ativos no sistema. Por conta disso, a importação não será possível.
          </Alert>
        )}

        {temItemIncompleto && (
          <Alert severity="warning" variant="filled">
            <strong>Atenção!</strong> Os itens em amarelo estão com dados
            faltando na planilha, ou não existe uma parametrização de valor para
            o item nessa atividade.
          </Alert>
        )}
      </>
    );
  }

  function mostrarAlertasSequencia() {
    const atividadesComErro = new Set<string>();

    dadosCarregados.forEach(item => {
      /* if (item.sequenciaCorreta === false) {
        atividadesComErro.add(item.atividade || 'Sem Atividade');
      } */
    });

    if (atividadesComErro.size === 0) return null;

    return (
      <Row>
        <Col sm="12" className="mt-4">
          {Array.from(atividadesComErro).map(atividade => {
            const itensDaAtividade = dadosCarregados
              .filter(i => (i.atividade || 'Sem Atividade') === atividade)
              .sort((a, b) => Number(a.sequencia) - Number(b.sequencia));

            return (
              <div key={`erro-seq-${atividade}`} className="mb-4">
                <Alert severity="error" variant="filled">
                  <strong>Atenção!</strong> Os itens da atividade {atividade}{' '}
                  não estão com a sequencia correta, Por conta disso, a
                  importação não será possível.
                </Alert>
                <div
                  className="mt-2"
                  style={{ maxHeight: '250px', overflowY: 'auto' }}
                >
                  <Table
                    className="align-items-center table-flush"
                    responsive
                    size="sm"
                  >
                    <thead className="thead-light">
                      <tr>
                        <th>Código</th>
                        <th>Descrição</th>
                        <th>Atividade</th>
                        <th>Sequência</th>
                        <th>Quantidade</th>
                      </tr>
                    </thead>
                    <tbody>
                      {itensDaAtividade.map((item: any) => (
                        <tr key={item.id}>
                          <td className="py-1">{item.codigo}</td>
                          <td className="py-1">{item.descricao}</td>
                          <td className="py-1">{item.atividade}</td>
                          <td className="py-1">{item.sequencia}</td>
                          <td className="py-1">{item.quantidade}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            );
          })}
        </Col>
      </Row>
    );
  }

  const readUploadFile = async (e: any) => {
    e.preventDefault();
    if (e.target.files) {
      setFileToSend(e.target.files[0]);
    }
  };

  useEffect(() => {
    if (isLoading) {
      toast.loading('Carregando arquivo....', { position: 'top-right' });
    } else {
      toast.dismiss();
    }
  }, [isLoading]);

  useEffect(() => {
    if (isSaving) {
      toast.loading('Realizando Carga dos Dados', { position: 'top-right' });
    } else {
      toast.dismiss();
    }
  }, [isSaving]);

  return (
    <>
      <Modal
        className="modal-dialog-centered"
        size="lg"
        isOpen={formModalState}
        toggle={() => setFormModalState(!formModalState)}
      >
        <div className="modal-body p-0">
          <Card className="bg-secondary shadow border-0">
            <CardHeader>
              <div className="text-center text-muted">{tipo}</div>
            </CardHeader>
            <CardBody className="px-lg-5 py-lg-5">
              <Row hidden={!carregarFinalidade}>
                <Col sm="12">
                  <strong>Finalidade *: </strong>
                  <Select
                    label="Finalidade"
                    value={finalidade ?? ''}
                    onChange={text => {
                      setFinalidade(String(text.target.value));
                    }}
                  >
                    <MenuItem value="">Selecione...</MenuItem>
                    <MenuItem value="M">Modernização</MenuItem>
                    <MenuItem value="R">Reposição</MenuItem>
                    <MenuItem value="E">Equipamento Especial</MenuItem>
                  </Select>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col sm="12">
                  <label htmlFor="fileUpload">
                    <strong>Selecione o arquivo: </strong>
                  </label>

                  <input
                    type="file"
                    name="fileUpload"
                    id="fileUpload"
                    onChange={readUploadFile}
                  />

                  <br />
                  <small className="mt-2">
                    Selecione um arquivo no formato .xlsx ou .xslm. Ao clicar em{' '}
                    <i>Carregar Arquivo</i>, o sistema fará um processamento e
                    mostrará uma prévia dos dados a serem carregados.{' '}
                  </small>
                </Col>
              </Row>
              <br />
              {/**
                 *

                <Row className="mt-2">
                <Col sm="12">
                <FormControlLabel
                control={
                  <Checkbox
                  checked={isImportarSemCadastro}
                  onChange={event =>
                  setIsImportarSemCadastro(prev => !prev)
                }
                color="primary"
                />
              }
              label="Importar sem cadastro"
              />
              </Col>
              </Row>
              */}
              <Row>
                {opcoes === Opcoes.Proposta ? (
                  <Col sm="12" className="mt-4">
                    <Button
                      color="primary"
                      onClick={uploadFile}
                      disabled={isLoading}
                    >
                      Carregar Arquivo
                    </Button>
                  </Col>
                ) : (
                  <Button
                    color="primary"
                    onClick={uploadFileConfiguracao}
                    disabled={isLoading}
                  >
                    Carregar Arquivo Configuração
                  </Button>
                )}
              </Row>
            </CardBody>
          </Card>
        </div>
      </Modal>

      <Modal
        className="modal-dialog-centered"
        size="xl"
        isOpen={modalConfirmacaoState}
        toggle={() => setModalConfirmacaoState(!modalConfirmacaoState)}
      >
        <div className="modal-body p-0">
          <Card className="bg-secondary shadow border-0">
            <CardHeader>
              <div className="text-center text-muted">{tipo}</div>
            </CardHeader>
            <CardBody className="px-lg-5 py-lg-5">
              <Row>
                <Col sm="12">
                  <small className="mt-2">
                    Ao clicar em <i>Confirmar Carga dos Dados</i> os itens
                    abaixo serão carregados na{' '}
                    {opcoes === Opcoes.Proposta ? 'proposta' : 'configuração'}.
                    Se houver alguma desconformidade, clique em <i>Cancelar</i>.
                  </small>

                  {mostrarAlerta()}
                </Col>
              </Row>
              <Row>
                <Col
                  sm="12"
                  className=" mt-3"
                  style={{ height: '300px', overflowY: 'scroll' }}
                >
                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                      <tr>
                        <th>Código</th>
                        <th>Descrição</th>
                        <th>Sequência</th>
                        <th>Quantidade</th>
                        <th>Atividade</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dadosCarregados.map((item: any) => {
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        const erroItem = !item.itemEncontrado ?? false;
                        const possuiErro = !item.valorEncontrado;
                        let style;

                        if (erroItem) {
                          style = {
                            backgroundColor: '#f55044',
                            color: '#FFFFFF',
                          };
                        } else if (possuiErro) {
                          style = {
                            backgroundColor: '#f5e344ff',
                            color: '#FFFFFF',
                          };
                        }

                        return (
                          <tr key={item.id} style={{ ...style }}>
                            <td className="py-1">{item.codigo}</td>
                            <td className="py-1">{item.descricao}</td>
                            <td className="py-1">{item.sequencia}</td>
                            <td className="py-1">{item.quantidade}</td>
                            <td className="py-1">{item.atividade}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </Col>
              </Row>
              {mostrarAlertasSequencia()}
              <Row>
                <Col sm="3" className="mt-4">
                  <Button
                    color="default"
                    onClick={() => {
                      setSessao('');
                      setModalConfirmacaoState(false);
                      setDadosCarregados([]);
                    }}
                    disabled={isSaving}
                  >
                    Cancelar
                  </Button>
                </Col>
                <Col sm="9" className="mt-4 d-flex justify-content-end">
                  {(() => {
                    const todosComErro =
                      dadosCarregados.length > 0 &&
                      dadosCarregados.every(
                        (item: any) => item.itemEncontrado === false,
                      );
                    const desabilitar =
                      isSaving || todosComErro || dadosCarregados.length === 0;

                    return opcoes === Opcoes.Proposta ? (
                      <Button
                        color="primary"
                        onClick={carregarDados}
                        disabled={desabilitar}
                        hidden={desabilitar}
                      >
                        Confirmar Carga dos Dados
                      </Button>
                    ) : (
                      <Button
                        color="primary"
                        onClick={carregarDadosConfiguracao}
                        disabled={desabilitar}
                        hidden={desabilitar}
                      >
                        Confirmar Carga dos Dados
                      </Button>
                    );
                  })()}
                </Col>
              </Row>
            </CardBody>
          </Card>
        </div>
      </Modal>

      <Button
        className="btn-icon btn-2 mr-1 m-3 "
        color="info"
        size="sm"
        onClick={() => setFormModalState(true)}
      >
        Adicionar {tipo}
      </Button>
    </>
  );
}
